
<script setup>
import { defineProps, computed } from "vue";
import UtilMoney from "@/utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__header">

            <div class="c-header__titulo">

                <h3 class="c-titulo">

                    Job {{ props?.dado?.codigo }}

                </h3>

                <div class="c-medidor .c-medidor--valor-job">

                    <v-chip class="c-medidor__chip"
                        color="primary"
                        dark
                        label
                    >

                        {{ props?.dado?.status }}

                    </v-chip>

                </div>

            </div>

            <div class="c-header__medidores">

                <div class="c-medidor .c-medidor--valor-na-previsao">

                    <v-chip class="c-medidor__chip"
                        color="green"
                        dark
                        label
                    >

                        Valor de Venda:
                        {{UtilMoney.toR$BRL(props?.dado?.valorDeVenda)}}

                    </v-chip>

                </div>

                <div class="c-medidor .c-medidor--valor-na-previsao">

                    <v-chip class="c-medidor__chip"
                        color="green"
                        dark
                        label
                    >

                        Valor de Venda (Com Impostos):
                        {{UtilMoney.toR$BRL(props?.dado?.valorDeVendaComImpostos)}}

                    </v-chip>

                </div>

            </div>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <div class="c-conjunto-de-campos">

                    <v-text-field class="c-campo__input"
                        label="Tipo de Job"
                        :value="props?.dado?.jobTipo"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Solicitacao de Orçamento"
                        :value="props?.dado?.solicitacaoDeOrcamentoCodigo"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Tipo de Equipamento"
                        :value="props?.dado?.solicitacaoDeOrcamentoTipoDeEquipamentoDescricao"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-conjunto-de-campos">

                    <v-text-field class="c-campo__input"
                        label="Data de Abertura"
                        :value="props?.dado?.dataAberturaFormatada"
                        prepend-icon="mdi-calendar" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Data de Entrega Contrutual"
                        :value="props?.dado?.dataEntregaContratualFormatada"
                        prepend-icon="mdi-calendar" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Data de Encerramento"
                        :value="props?.dado?.dataEncerramentoFormatada"
                        prepend-icon="mdi-calendar" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-conjunto-de-campos">

                    <v-text-field class="c-campo__input"
                        label="Comercial"
                        :value="props?.dado?.comercialNome"
                        prepend-icon="mdi-account" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Gestor de Contrato"
                        :value="props?.dado?.gestorNome"
                        prepend-icon="mdi-account" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Coordenador de Contratos"
                        :value="props?.dado?.coordenadorNome"
                        prepend-icon="mdi-account" 
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <v-text-field class="c-campo__input"
                    label="Tipo de Venda"
                    :value="props?.dado?.tipoVenda"
                    outlined
                    disabled
                    return-object
                ></v-text-field>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__header{
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px; 
}

.c-header__titulo{
    display: grid;
    grid-template-columns: max-content max-content;
    grid-template-rows: max-content; 
    gap: 10px; 
}

.c-conjunto-de-campos{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 0px 20px;
}

</style>